import type { AuthDataResult } from '../types/token-manager';

import { widgetApi } from '../../config';

interface AuthCaptchaValidateParams {
  successToken: string;
  oldToken?: string;
  widgetUuid: string;
}

export const getAuthCaptchaValidate = async ({
  successToken,
  oldToken,
  widgetUuid,
}: AuthCaptchaValidateParams): Promise<AuthDataResult> => {
  try {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (oldToken) {
      headers.Authorization = `Bearer ${oldToken}`;
    }

    const response = await fetch(`${widgetApi}/auth/captcha/validate`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        successToken,
        widgetUuid,
      }),
    });

    if (!response.ok) {
      return {
        ok: false,
        status: response.status,
        token: '',
        userUuid: '',
      };
    }

    const data = await response.json();

    return {
      ok: true,
      status: response.status,
      token: data.token,
      userUuid: data.userUuid,
    };
  } catch (_) {
    throw new Error('Произошла ошибка при выполнении метода getAuthCaptchaValidate');
  }
};
